import { Box, FormControl, FormHelperText } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './SGSFileInput.module.scss';
import classnames from 'classnames';

export type SGSFileInputProps = React.HTMLAttributes<HTMLInputElement> & {
    label?: string;
    error?: boolean;
    helperText?: string;
    name?: string;
    image?: string;
    onDeleteImage?: any;
    value?: any;
};

const SGSFileInput: React.FC<SGSFileInputProps> = ({
    id,
    image,
    onDeleteImage,
    name,
    error,
    helperText,
    label,
    ...props
}) => {
    const { t } = useTranslation();
    return (
        <FormControl error={error}>
            {label && <label htmlFor={id || name}>{label}</label>}
            {image && (
                <div>
                    <div>{t('components.input.currentImage')}</div>
                    <Box className="mb-2">
                        <img src={image} className="mw-100" alt={t('components.input.currentImage')} />
                        <Box>
                            <Box
                                component="span"
                                className={classnames(styles.deleteButton, 'ml-2')}
                                onClick={onDeleteImage}
                            >
                                <i className="fas fa-trash-alt mr-2" />
                                <span>{t('global.delete')}</span>
                            </Box>
                        </Box>
                    </Box>
                </div>
            )}
            <input id={id || name} type="file" {...props}></input>
            {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
    );
};

export default SGSFileInput;
